import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllWithdrawals,
  approveWithdrawal,
  rejectWithdrawal,
  startProcessingWithdrawal,
} from "../redux/WithdralSlice/withdrawalSlice";
import moment from "moment";
import {
  Autorenew,
  HourglassEmpty,
  CheckCircle,
  Cancel,
} from "@mui/icons-material";

const AdminWithdrawals = () => {
  const dispatch = useDispatch();
  const { withdrawals, loading } = useSelector((state) => state?.withdrawals);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    dispatch(fetchAllWithdrawals());
  }, [dispatch]);

  const handleStartProcessing = (withdrawalId) => {
    console.log("Starting processing for withdrawalId:", withdrawalId);
    dispatch(startProcessingWithdrawal({ withdrawalId }));
  };

  const handleApprove = async (withdrawalId) => {
    console.log("Starting processing for withdrawalId:", withdrawalId);
    const transactionId = prompt("Enter transaction ID:");
    if (transactionId) {
      dispatch(approveWithdrawal({ withdrawalId, transactionId }));
    }
  };

  const handleReject = async (withdrawalId) => {
    console.log("Starting processing for withdrawalId:", withdrawalId);
    const reason = prompt("Enter rejection reason:");
    if (reason) {
      dispatch(rejectWithdrawal({ withdrawalId, reason }));
    }
  };

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  const statusStyles = {
    pending: "bg-yellow-100 text-yellow-700 border-yellow-500",
    approved: "bg-green-100 text-green-700 border-green-500",
    rejected: "bg-red-100 text-red-700 border-red-500",
    processing: "bg-gray-100 text-gray-700 border-gray-500",
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
        Admin - Manage Withdrawals
      </h1>

      {loading ? (
        <p className="text-center text-blue-500">Loading withdrawals...</p>
      ) : withdrawals.length === 0 ? (
        <p className="text-center text-gray-500">No withdrawals found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200  rounded-lg">
            <thead className=" text-gray-700">
              <tr>
                <th className="p-3 text-left border-b">Amount</th>
                <th className="p-3 text-left border-b">Requested Date</th>
                <th className="p-3 text-left border-b">updated Date</th>
                <th className="p-3 text-left border-b">Status</th>
                <th className="p-3 text-left border-b">Actions</th>
              </tr>
            </thead>
            <tbody>
              {withdrawals.map((w) => (
                <tr key={w._id} className="border-b hover:bg-gray-50">
                  <td className="p-3 text-gray-800 font-medium">
                    ₹{w.amount.toFixed(2)}
                  </td>
                  <td className="p-3 text-gray-600">
                    {moment(w.createdAt).format("DD MMM YYYY, hh:mm A")}
                  </td>
                  <td className="p-3 text-gray-600">
                    {moment(w.updatedAt).format("DD MMM YYYY, hh:mm A")}
                  </td>
                  <td className="p-3">
                    {w.status === "approved" && (
                      <span className="text-green-600 font-medium">
                        ✔ Completed
                      </span>
                    )}
                    {w.status === "rejected" && (
                      <span className="text-red-600 font-medium">
                        ✖ Rejected
                      </span>
                    )}
                    {w.status === "pending" && (
                      <span className="flex items-center gap-1  py-1 text-sm font-semibold  text-yellow-700 border-yellow-500">
                        <HourglassEmpty fontSize="small" /> Pending
                      </span>
                    )}
                    {w.status === "processing" && (
                      <span className="flex items-center gap-1  py-1 text-sm font-semibold text-gray-700 border-gray-500">
                        <Autorenew fontSize="small" className="animate-spin" />{" "}
                        Processing
                      </span>
                    )}
                  </td>
                  <td className="p-3 relative">
                    <button
                      className={`w-32 flex items-center justify-between px-3 py-1 text-sm font-semibold border rounded-lg ${
                        statusStyles[w.status.toLowerCase()]
                      }`}
                      onClick={() => toggleDropdown(w._id)}
                      disabled={
                        w.status === "approved" || w.status === "rejected"
                      }
                    >
                      {w.status.charAt(0).toUpperCase() + w.status.slice(1)}
                      {w.status !== "approved" && w.status !== "rejected" && (
                        <span className="ml-2">▼</span>
                      )}
                    </button>
                    {openDropdown === w._id && (
                      <div className="absolute z-10 mt-2 bg-white border shadow-lg rounded-md w-32">
                        {w.status === "pending" && (
                          <button
                            onClick={() => handleStartProcessing(w._id)}
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            Processing
                          </button>
                        )}
                        {w.status === "processing" && (
                          <>
                            <button
                              onClick={() => handleApprove(w._id)}
                              className="block w-full px-4 py-2 text-sm text-green-700 hover:bg-gray-100"
                            >
                              Approve
                            </button>
                            <button
                              onClick={() => handleReject(w._id)}
                              className="block w-full px-4 py-2 text-sm text-red-700 hover:bg-gray-100"
                            >
                              Reject
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminWithdrawals;
